
import React from "react";
import queryString from 'query-string';
import { Button, Progress, Alert, Input, FormFeedback } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import header from './img/header.png';
import logo from './img/logo-sm.png'

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'hvtv';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: '',
      showPassword: false,
      invalidUserName: false,
      invalidPass: false
    };
    this.viewPassword = this.viewPassword.bind(this);

  }

  componentDidMount() { this.setState({ showForm: true }) }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }


  async onSubmit(ev) {
    ev.preventDefault();
    if (!this.state.username) {
      this.setState({ invalidUserName: true })
      setTimeout(() => {
        this.setState({ invalidUserName: false })
      }, 3000);
      return
    }
    if (!this.state.password) {
      this.setState({ invalidPass: true })
      setTimeout(() => {
        this.setState({ invalidPass: false })
      }, 3000);
      return
    }

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });




    this.props.api.userPassLogin(
      {
        username: this.state.username,
        password: this.state.password,
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);
        let message = 'Correo Electronico o Contraseña Errada.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  viewPassword() {
    let togglerStatus = this.state.showPassword; //check the status of the toggle you clicked
    this.setState({ showPassword: !togglerStatus })
  }

  render() {


    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className='panel' ref={this.ref}>
          <div >
            <img src={header} alt={'header'}></img>
          </div>
          <div className='panel-body'>
            <form onSubmit={event => this.onSubmit(event)}>
              <div className='form-group mb-sm'>
                <label className="lbl-hvtv"></label>
                <div className='input-group ' data-tip="Ingrese su correo electrónico">
                  <Input
                    className="form-control form-control-rounded input-sm email-input-hvtv user-input-hvtv"
                    disabled={this.state.onLogin}
                    tabIndex={1}
                    type="email"
                    autoCorrect="off"
                    autoCapitalize="none"
                    placeholder="Correo electrónico"
                    name="username"
                    invalid={this.state.invalidUserName}
                    onChange={e => this.setState({ username: e.target.value })}
                  />
                  <div className="input-group-prepend">

                    <span className="input-group-text inputSpan"><FontAwesomeIcon icon={faUser} color="rgba(0,0,0,0.2)" /></span>
                  </div>
                  <FormFeedback tooltip className="input-error-msg">Ingrese su correo electrónico</FormFeedback>
                </div>
              </div>
              <div className='form-group mb-sm'>
                <label className="lbl-hvtv"></label>
                <div className='input-group ' data-tip="Ingrese su Contraseña">
                  <Input
                    className="form-control input-sm pass-input-hvtv"
                    disabled={this.state.onLogin}
                    tabIndex={1}
                    type={this.state.showPassword ? "text" : "password"}
                    autoCorrect="off"
                    autoCapitalize="none"
                    placeholder="Contraseña"
                    name="password"
                    invalid={this.state.invalidPass}
                    onChange={e => this.setState({ password: e.target.value })}
                  />
                  <div className="input-group-prepend">
                    <span className=" input-group-text view inputSpan" onClick={this.viewPassword} data-toggle="tooltip" data-placement="right" title="Click para Ver Contraseña">
                      <FontAwesomeIcon icon={this.state.showPassword ? faLockOpen : faLock} color="rgba(0,0,0,0.4)" />
                    </span>
                  </div>
                  <FormFeedback tooltip className="input-error-msg">Ingrese su Contraseña</FormFeedback>
                </div>
              </div>
              <div className='row'>
                <center>

                  {!this.state.onLogin ?
                    <Button
                      block={!this.parameters.failureRedirect}
                      tabIndex={1}
                      className="btn btn-primary ml-10"
                      type="submit"
                      name="submit"
                      disabled={this.state.invalidUserName || this.state.invalidPass || !this.props.turnstileSuccess}
                    >
                      Inicio Sesión
                    </Button> :
                    <Progress animated color="danger" value={100} />}

                </center>
              </div>
              <div className="row">
                <div className="messages-container">
                  <Alert color="danger" id="error-message" className='error' isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                    {this.state.error.message}
                  </Alert>
                </div>
                <div className="text-container">
                  <p>
                    ¿Olvidaste tu contraseña?
                    <a href="https://oficinavirtual.hvmultiplay.co/client/recoverPassword">
                      <font color="orange"> Recupérala</font>
                    </a><br></br>
                    ¿No tienes Usuario HV Play?
                    <a href="https://oficinavirtual.hvmultiplay.co/client/register/stepOne">
                      <font color="orange"> Actívalo aqui!</font>
                    </a>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="logo-hvtv">
                  <img src={logo} alt={"logo"} width="150px"></img>
                </div>
              </div>
              <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
            </form>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
